import { QuestionCircleOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import React from 'react';

import styles from './LabelCell.module.scss';

type BaseProps = {
  label: string;
  className?: string;
  labelClassName?: string;
};

type WithInfoIcon = {
  hasInfoIcon: true;
  tooltipTitle: React.ReactNode;
};

type WithoutInfoIcon = {
  hasInfoIcon?: false;
  tooltipTitle?: never;
};

type WithSettings = {
  hasSettings: true;
  onSettingClick: () => void;
};

type WithoutSettings = {
  hasSettings?: false;
  onSettingClick?: never;
};

export type LabelCellProps = BaseProps &
  (WithInfoIcon | WithoutInfoIcon) &
  (WithSettings | WithoutSettings);

const LabelCellComponent: React.FC<LabelCellProps> = ({
  label,
  className = '',
  labelClassName = '',
  hasInfoIcon = false,
  tooltipTitle,
  hasSettings = false,
  onSettingClick,
}) => {
  return (
    <div className={classNames(styles.labelCell, className)}>
      <div className={classNames(styles.label)}>
        <span className={classNames(labelClassName)}>{label}</span>
        {hasInfoIcon && tooltipTitle && (
          <Tooltip title={tooltipTitle}>
            <QuestionCircleOutlined className={styles.infoIcon} />
          </Tooltip>
        )}
      </div>
      {hasSettings && (
        <Button
          icon={<SettingOutlined />}
          onClick={onSettingClick}
          className={styles.buttonContainer}
        />
      )}
    </div>
  );
};

export const LabelCell = React.memo(LabelCellComponent);
